module.exports = __webpack_public_path__ + "static/media/theZoneSample.9507a065.xlsx";